import { render } from "./FeaturingsPage.vue?vue&type=template&id=34f5bfc0&scoped=true"
import script from "./FeaturingsPage.vue?vue&type=script&lang=js"
export * from "./FeaturingsPage.vue?vue&type=script&lang=js"

import "./FeaturingsPage.vue?vue&type=style&index=0&id=34f5bfc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f5bfc0"]])

export default __exports__